

// Roles permitidos de usaurios
export const rolesClientes = ['CLIENTE', 'DISTRIBUIDOR', 'PUBLICISTA', 'EMPRESA'];
export const roles_permitidos = ['SUPERADMIN','ADMINISTRADOR','DISENIADOR','PRODUCCION','DISTRIBUIDOR','PUBLICISTA','EMPRESA','MARKETING', 'CLIENTE']
export const rolesdeEdicion = ['SUPERADMIN', 'ADMIN', 'DISENIO'];
// Areas de Cambio de los items de produccion
export const itemProduccion = ['Diseño', 'Impresión', 'Acabados', 'Producción', 'Instalación', 'Despacho', 'Entregado'];
// Datos de Formulario de Pedidos
export const nombreSoloCantidad = ["MARKETING DIGITAL", "CARAMAÑOLAS", "SERVICIOS", "PAD MOUSE", "LLAVEROS", "FOTOS CUADROS RETABLOS", "SELLOS", "BOTONES", "AGENDAS", "SEÑALIZACION", "IMPRESION LASER", "SERVICIO-TECNICO"];
export const cantidadColor = ["CINTAS-PORTACARNETS", "TULAS", "MUGGS", "ALMOHADAS"];
export const prendas = ["PRENDAS", 'SEVEN SPORT'];
export const litografia = ["LITOGRAFIA"];
export const estructurasEcosolvente = ["ESTRUCTURAS", "IMPRESION ECOSOLVENTE", "CORTE LASER", "SOLO MATERIAL"];
export const cantidax50 = ["MANILLAS", "BOMBAS", "ESFEROS"];
export const cantidax10 = ["TALONARIOS"];
export const corteVinilo = ["CORTE-VINILO"];

// Roles mapeados
export const roleCompra = {
    cliente: 'Cliente',
    distri: 'Distribuidor',
    publicista: 'Publicista',
    empresa: 'Empresa',
}

// Valores segun rol de ventas
export const VALOR_PRECIO = {
    cliente: 'totalCliente',
    distri: 'totalDistri',
    empresa: 'totalEmpresa',
    publicista: 'totalPublicista',
};


// Medios de Pagos 
export const mediosPago = ['Efectivo', 'Nequi', 'Daviplata', 'Bancolombia', 'Davivienda'];
// Estados en Ops de Produccion
export const estadosOp = ['Verificar Pago', 'Diseño', 'Pendiente Aprobacion', 'Produccion', 'Para Entregar', 'Credito', 'Entregado'];
// Estados de Pagos de Op
export const pagosOp = ['PENDIENTE', 'REALIZADO', 'CREDITO'];
// Roles de pedidos
export const rolesPedido = ['cliente', 'distri', 'publicista', 'empresa'];
// Estados de Tipos de pago
export const tiposPago = ['CREDITO', 'CONTADO'];
// Colores para comprar en Carrito
export const coloresCarrito = [ 'Negro', 'Blanco', 'Morado', 'Rosado', 'Fucsia', 'Azul Oscuro', 'Azul Rey', 'Gris Claro', 'Gris Oscuro', 'Azul Cielo', 'Rojo', 'Verde', 'Vinotinto', 'Lila', 'Naranja', 'Amarillo' ] 
// Tallas para comprar en Carrito
export const tallasCarrito = [ '3-6', '6-12', '12-18', '2', '4', '6', '8', '10', '12', '14', '16', 'S', 'M', 'L', 'XL'];
// Genero para comprar en Carrito
export const generoCarrito = [ 'Niño', 'Mujer', 'Hombre' ];
// Diseño para comprar en Carrito
export const disenioCarrito = [ 'Con Diseño', 'Sin Diseño' ];
// Unidades de medida comprar en Carrito
export const unidadesMedida = [ 'Centimetros', 'Metros' ];
















